import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

const ChatIcon = RESIDENTS_SVG_COMPONENTS.CONVERSATION;
const FlagIcon = RESIDENTS_SVG_COMPONENTS.FINISH;

interface ActionButtonRowProps {
  onContactPress?: () => void;
  onReportPress?: () => void;
  contactLabel?: string;
  showReportButton?: boolean;
  hideContactButton?: boolean;
}

/**
 * Reusable action button row with contact and report buttons
 */
export const ActionButtonRow: React.FC<ActionButtonRowProps> = ({
  onContactPress,
  onReportPress,
  contactLabel = 'Contact seller',
  showReportButton = true,
  hideContactButton = false,
}) => (
  <View style={styles.container}>
    {!hideContactButton && onContactPress && (
      <TouchableOpacity 
        style={styles.contactButton} 
        onPress={onContactPress}
        activeOpacity={0.8}
      >
        <ChatIcon width={18} height={18} color={MARKETPLACE_COLORS.background} />
        <Text style={styles.contactButtonText}>{contactLabel}</Text>
      </TouchableOpacity>
    )}
    
    {showReportButton && onReportPress && (
      <TouchableOpacity 
        style={[styles.reportButton, hideContactButton && styles.reportButtonFullWidth]} 
        onPress={onReportPress}
        activeOpacity={0.8}
      >
        <FlagIcon width={20} height={20} color={MARKETPLACE_COLORS.textPrimary} />
        {hideContactButton && (
          <Text style={styles.reportButtonText}>Report listing</Text>
        )}
      </TouchableOpacity>
    )}
  </View>
);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 16,
  },
  contactButton: {
    flex: 1,
    height: 34,
    backgroundColor: MARKETPLACE_COLORS.accentRed,
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    paddingHorizontal: 16,
  },
  contactButtonText: {
    fontSize: 12,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.background,
  },
  reportButton: {
    width: 34,
    height: 34,
    backgroundColor: MARKETPLACE_COLORS.white5Percent,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: 6,
  },
  reportButtonFullWidth: {
    flex: 1,
    width: 'auto',
    paddingHorizontal: 16,
  },
  reportButtonText: {
    fontSize: 12,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.textSecondary,
  },
});

